import React from 'react';
import { Layout, Typography, Avatar, Dropdown, Menu, Space } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import logo from '../assets/logos/yofi.svg';

const { Header: AntHeader } = Layout;
const { Title } = Typography;

const Header = ({ userInfo, selectedService, onLogout }) => {
  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
  };

  const userMenu = (
    <Menu>
      {userInfo.email && (
        <Menu.Item key="email" disabled style={{ opacity: 1, cursor: 'default' }}>
          {userInfo.email ? userInfo.email.split(',')[0].trim() : ''}
        </Menu.Item>
      )}
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <AntHeader style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img 
          src={logo}
          alt="Yofi Logo" 
          className="logo" 
        />
        <Title level={4} style={{ color: 'white', margin: 0 }}>
          Service Center {selectedService && `| ${selectedService.name}`}
        </Title>
      </div>
      
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Dropdown overlay={userMenu} trigger={['click']}>
            <Space>
              <Avatar icon={<UserOutlined />} src={userInfo.avatar} />
              <span>{userInfo.email ? userInfo.email.split(',')[0].trim() : 'User'}</span>
            </Space>
        </Dropdown>
      </div>
    </AntHeader>
  );
};

export default Header; 